import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { products } from '../data/products';
import ProductCard from '../components/ProductCard';
import './ProductDetail.css';

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = products.find(p => p.id === Number(id));
  const { dispatch } = useCart();

  const [selectedSize, setSelectedSize] = useState(null);
  const [activeImg, setActiveImg] = useState(0);
  const [added, setAdded] = useState(false);
  const [error, setError] = useState('');

  if (!product) return (
    <div className="not-found">
      <h2>Piece not found</h2>
      <Link to="/shop">Return to Shop</Link>
    </div>
  );

  const related = products.filter(p => p.id !== product.id && p.category === product.category).slice(0, 4);

  const handleAdd = () => {
    if (!selectedSize) { setError('Please select a size'); return; }
    dispatch({
      type: 'ADD_ITEM',
      payload: {
        id: product.id,
        name: product.name,
        price: product.price,
        size: selectedSize,
        image: product.images[0],
      }
    });
    setAdded(true);
    setError('');
    setTimeout(() => setAdded(false), 2200);
  };

  return (
    <main className="product-detail page-enter">
      {/* Breadcrumb */}
      <nav className="breadcrumb">
        <Link to="/">Home</Link>
        <span>/</span>
        <Link to="/shop">Shop</Link>
        <span>/</span>
        <span>{product.name}</span>
      </nav>

      <div className="detail-layout">
        {/* Images */}
        <div className="detail-images">
          <div className="thumbs">
            {product.images.map((img, i) => (
              <button
                key={i}
                className={`thumb ${activeImg === i ? 'active' : ''}`}
                onClick={() => setActiveImg(i)}
              >
                <img src={img} alt={`${product.name} view ${i + 1}`} />
              </button>
            ))}
          </div>
          <div className="main-image">
            {product.badge && <span className="detail-badge">{product.badge}</span>}
            <img src={product.images[activeImg]} alt={product.name} />
          </div>
        </div>

        {/* Info */}
        <div className="detail-info">
          <p className="detail-category">{product.category}</p>
          <h1 className="detail-name">{product.name}</h1>
          <p className="detail-price">€{product.price}</p>

          {product.colors && (
            <div className="color-section">
              <span className="color-label">Colour: <em>{product.colors[0]}</em></span>
              <div className="color-list">
                {product.colors.map((c, i) => (
                  <span key={i} className="color-chip">{c}</span>
                ))}
              </div>
            </div>
          )}

          <p className="detail-desc">{product.description}</p>

          {/* Size selector */}
          <div className="size-section">
            <div className="size-header">
              <span className="size-label">Select Size</span>
              <a href="#" className="size-guide">Size Guide</a>
            </div>
            <div className="sizes-grid">
              {product.sizes.map(size => (
                <button
                  key={size}
                  className={`size-btn ${selectedSize === size ? 'selected' : ''}`}
                  onClick={() => { setSelectedSize(size); setError(''); }}
                >
                  {size}
                </button>
              ))}
            </div>
            {error && <p className="size-error">{error}</p>}
          </div>

          {/* Actions */}
          <div className="detail-actions">
            <button className={`add-to-bag ${added ? 'added' : ''}`} onClick={handleAdd}>
              {added ? (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  Added to Bag
                </>
              ) : 'Add to Bag'}
            </button>
            <Link to="/checkout" className="buy-now-btn">Buy Now</Link>
          </div>

          {/* Details accordion */}
          <div className="detail-accordion">
            <details className="accordion-item">
              <summary className="accordion-summary">Composition & Care</summary>
              <div className="accordion-body">
                <p>Dry clean only. Store folded in a cool, dark place. Avoid prolonged exposure to direct sunlight. Each piece is made with the understanding that it will be worn for decades.</p>
              </div>
            </details>
            <details className="accordion-item">
              <summary className="accordion-summary">Shipping & Returns</summary>
              <div className="accordion-body">
                <p>Complimentary shipping on orders over €250. Standard delivery 3–5 business days. Returns accepted within 14 days in original unworn condition.</p>
              </div>
            </details>
            <details className="accordion-item">
              <summary className="accordion-summary">About This Piece</summary>
              <div className="accordion-body">
                <p>Each Alainn piece is produced in small batches with independent ateliers who share our values of craft, longevity, and beauty. Every item is quality-checked by hand before dispatch.</p>
              </div>
            </details>
          </div>
        </div>
      </div>

      {/* Related */}
      {related.length > 0 && (
        <section className="related-section">
          <div className="related-header">
            <p className="section-eyebrow">You May Also Love</p>
            <h2 className="section-title-sm">Related Pieces</h2>
          </div>
          <div className="related-grid">
            {related.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        </section>
      )}
    </main>
  );
}
